/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
;;
import { Button, Columns, Column, MuiTitle, Container, Field } from 'src/ui/mui-ui-kit';;;
import { Form, Field as FormField, FormSpy } from 'react-final-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import propTypes from 'prop-types';
import { toast } from 'react-toastify';
import { useParams, useNavigate } from 'react-router-dom';
import { SolventLogo, UiInputAdapter, UiToastAdapter } from 'src/ui';
import {
  required,
  composeValidators,
  minLength,
  matches,
} from 'src/ui/validations';
import { PasswordRequirements } from '../components';
import { createPassword, changePassword } from '../services';
import { LoginImage } from '../../ui';

const validationRegexes = [/([A-Z]+)/, /([a-z]+)/, /(\W)/, /(\d)/];

class CreatePasswordPageComponent extends Component {
  state = {
    isWhiteLabel: window.location.host.includes('nexaflow'),
    // isWhiteLabel: true
  };

  handleSubmit = async ({ password }) => {
    const { params, navigate } = this.props;
    const { activationToken, token } = params;

    let result = { ok: false };

    if (activationToken) {
      result = await createPassword(activationToken, password);
    } else if (token) {
      result = await changePassword(token, password);
    }

    if (!result.ok) {
      toast(
        UiToastAdapter(
          'The token being used is invalid. Please, contact Solvent.',
          'danger'
        )
      );
    } else {
      toast(
        UiToastAdapter(
          'Password changed successfully, you may now log in.',
          'success'
        )
      );
      navigate('/');
    }
  };

  render() {
    const { isWhiteLabel } = this.state;

    return (
      <Container
        className={
          isWhiteLabel ? 'create-password-nexaflow' : 'create-password'
        }
      >
        <Form
          onSubmit={this.handleSubmit}
          validate={values => {
            const errors = {};
            errors.confirmPassword = matches(
              'Password',
              values.password
            )('Confirm Password')(values.confirmPassword);
            return errors;
          }}
          subscription={{ values: true }}
          render={({ handleSubmit, submitting, hasValidationErrors, values }) => {
            const password = values.password || '';
            const hasEightCharacters = minLength(8)('Password')(password) === undefined;
            const hasSpecialCharacters = validationRegexes.every(regex =>
              regex.test(password)
            );
            const isPasswordValid = hasEightCharacters && hasSpecialCharacters;
            const passwordValidation = { hasEightCharacters, hasSpecialCharacters };

            return (
              <form onSubmit={handleSubmit}>
                <Columns
                  className="create-password-form"
                >
                  <Column>
                    <div className="left-column">
                      {!isWhiteLabel ? null : ( // <SolventLogo />
                        <img
                          src={require('../../ui/assets/NexaFlow-logo.jpg')}
                          alt="NexaFlow"
                          style={{ paddingBottom: '25px', paddingLeft: '40px' }}
                        />
                      )}
                      <MuiTitle isSize={6} tag="h2" hasTextColor="secondary">
                        Create Password
                      </MuiTitle>

                      <FormField
                        name="password"
                        component={UiInputAdapter}
                        validate={required('Password')}
                        label="Password"
                        type="password"
                        id="password"
                        renderIcons={() => [
                          <span className="icon is-small is-right" key="lock">
                            <FontAwesomeIcon icon={['fal', 'lock-alt']} size="sm" />
                          </span>,
                        ]}
                        hasIcons="right"
                        disabled={submitting}
                        autoFocus
                        required
                        hideAsterisk
                      />

                      <FormField
                        name="confirmPassword"
                        component={UiInputAdapter}
                        validate={composeValidators('Confirm Password', required)}
                        label="Confirm Password"
                        type="password"
                        id="confirmPassword"
                        renderIcons={() => [
                          <span className="icon is-small is-right" key="lock">
                            <FontAwesomeIcon icon={['fal', 'lock-alt']} size="sm" />
                          </span>,
                        ]}
                        hasIcons="right"
                        disabled={submitting}
                        required
                        hideAsterisk
                      />
                      {/* <GenericPasswordRequirements {...passwordValidation} /> */}
                      <Field>
                        <Button
                          isColor="gradient-bright"
                          className="is-long"
                          disabled={
                            submitting ||
                            hasValidationErrors ||
                            !isPasswordValid
                          }
                          isLoading={submitting}
                          type="submit"
                        >
                          Confirm
                        </Button>
                      </Field>
                    </div>
                  </Column>
                  <Column className="right-column">
                    <PasswordRequirements {...passwordValidation} />
                    {/* <LoginImage image={require('../../ui/assets/reset-password.png')}/> */}
                  </Column>
                  {!isWhiteLabel && (
                    <Column>
                      <LoginImage
                        image={require('../../ui/assets/reset-password.png')}
                      />
                    </Column>
                  )}

                </Columns>
              </form>
            )
          }}
        />
      </Container>
    );
  }
}

CreatePasswordPageComponent.propTypes = {
  params: propTypes.object.isRequired,
  navigate: propTypes.func.isRequired,
};

// Wrapper component to use React Router v6 hooks and pass them to the class component
export function CreatePasswordPage() {
  const params = useParams();
  const navigate = useNavigate();

  return <CreatePasswordPageComponent params={params} navigate={navigate} />;
}
